/****************
 * THE ORB FILLING A STRATEGY FIELD, WITH THE USER'S YES. 2026-10-24.
 *
 * Twin file: frontend/src/lib/orbFill.core.ts and mobile-app/src/lib/orbFill.core.ts
 * must be byte-identical. The fields the Orb may fill (backend
 * rest/assistant_fill.go holds the same names and ranges, a test reads both).
 *
 * The Orb's answer carries `fill: [{field, value}]`; the chat shows a
 * "Fill it in" button; pressing it sends ORB_FILL_EVENT, which the Strategy
 * Builder (web VirginDashboard, phone strategy/index.tsx) applies to its form.
 * Opened from another page, the change waits here until the builder mounts.
 ****************/

export interface FillChange {
  field: string;
  value: string;
}

export const FILL_FIELDS = [
  'max_leverage',
  'max_trades',
  'margin_type',
  'direction',
  'order_type',
  'stop_loss_pct',
  'take_profit_pct',
  'stop_loss_usd',
  'take_profit_usd',
  'trailing_stop_usd',
  'kill_drawdown_pct',
  'kill_losing_streak',
] as const;

export const ORB_FILL_EVENT = 'copyfi:orb-fill';

let pending: FillChange[] | null = null;
let buildersOpen = 0;

/** The builder says it is on screen; the returned function says it left. */
export function builderOpened(): () => void {
  buildersOpen += 1;
  return () => { buildersOpen -= 1; };
}

/**
 * Called by the chat's button. With the builder open, `send` delivers it now;
 * otherwise it waits for the builder and the caller opens it. Returns whether
 * the builder was open.
 */
export function requestFill(changes: FillChange[], send: (changes: FillChange[]) => void): boolean {
  if (buildersOpen > 0) {
    send(changes);
    return true;
  }
  pending = changes;
  return false;
}

/** The builder takes what was asked before it was open. */
export function takePendingFill(): FillChange[] | null {
  const p = pending;
  pending = null;
  return p;
}

/** How a change reads on the button: the field's label key and the value as shown. */
export function fillValueText(c: FillChange): string {
  if (c.field === 'max_leverage') return `${c.value}x`;
  if (c.field.endsWith('_pct')) return `${c.value}%`;
  if (c.field.endsWith('_usd')) return `$${c.value}`;
  return c.value;
}
